var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{name: 'player_resource_log_copy', params: {playerId: _vm.playerId, copyId: _vm.copyId}}}},[_vm._v("\n  "+_vm._s(_vm.lable)+" "+_vm._s(_vm.copyId)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }